import React, { Component } from 'react';
import { connect } from 'react-redux';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import { Field, reduxForm, Form, isDirty } from 'redux-form';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import { CircularProgress } from 'material-ui/Progress';
import { Link, Prompt } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import AddIcon from 'material-ui-icons/AddCircle';
import EditIcon from 'material-ui-icons/Edit';
import Popover from 'material-ui/Popover';
import Tooltip from '@material-ui/core/Tooltip';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';
import addEditCustomer from '../../../actions/addEditCustomer';


import addEditLocation from '../../../actions/addEditLocation';
import getCustomers from '../../../actions/getCustomers';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import renderCheckBoxGroup from '../../../helpers/RenderCheckBoxGroup';
import RenderDialog from '../../../helpers/RenderDialog';
import { removeWhiteSpace, filterCustomersByProduct, isUserATSysAdmin } from '../../../helpers/Util';

import renderTextField from '../../../helpers/RenderTextFiledWithDiv';
import validationHelper from '../../../helpers/ValidationHelper';
import normalizePhone from '../../../helpers/NormalizePhone';
import renderTextArea from '../../../helpers/RenderTextArea';

import RenderConfirmationTimeoutDialog from '../../../helpers/RenderConfirmationTimeoutDialog';

import AddressForm from '../../../containers/AddressForm';
import Layout from '../../Layout';
import search from '../../../actions/search';
import { ProductMap } from '../../../helpers/ProductMap';

import AutoComplete from '../../../helpers/AutoComplete';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  '@media only screen and (max-width: 1000px)': {
    card: {
      display: 'block'
    }
  },
  content: {
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '5vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    width: '22%',
    marginLeft: '43%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  messageStyle: {
    paddingLeft: '15px',
    paddingTop: '10px'
  },
  '@media screen and (max-width: 1130px)': {
    buttonStyle: {
      flexWrap: 'wrap',
      textAlign: 'center'
    },
  },
  buttonSize: {
    minWidth: 123,
    height: 36
  },
  marginStyle: {
    margin: 8
  },
  addressFieldMarginStyle: {
    marginLeft: 16
  },
  textAddressField: {
    width: 350,
    marginLeft: 16
  },
  '@media only screen and (max-width: 1001px)': {
    addressFieldMarginStyle: {
      width: '90%',
      margin: '10px 0 -30px 0'
    },
    textAddressField: {
      width: '100%',
      marginLeft: 0
    },
  },
  textField: {
    width: 350,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '4%',
    textAlign: 'left',
    opacity: '0.7'
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  addressAddIcon: {
    position: 'absolute',
    margin: '1%'
  },
  activityButtonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '22%',
    display: 'flex',
    justifyContent: 'center',
    minWidth: 123,
    height: 36,
    marginBottom: 30,
    color: 'white',
    textTransform: 'Capitalize'
  }
});

const StyledPopover = withStyles({
  paper: {
    overflowX: 'visible',
    overflowY: 'visible',
  }
})(Popover);

const validate = (values) => {
  const errors = validationHelper.validateRequired(['locationID', 'locationName', 'contactName',
    'address', 'phoneNumber', 'emailAddress', 'autotecId',
    'linkCustomer', 'addressLine1', 'city', 'state', 'county', 'country', 'postalCode'], values);
  if (values.emailAddress && !validationHelper.validateEmail(values.emailAddress)) {
    errors.emailAddress = 'Invalid email address';
  }
  if (values.phoneNumber && !validationHelper.validatePhone(values.phoneNumber)) {
    errors.phoneNumber = 'Invalid phone number';
  }
  if (values.faxNumber && !validationHelper.validatePhone(values.faxNumber)) {
    errors.faxNumber = 'Invalid fax number';
  }

  const lengthValidation = [
    { field: 'locationID', label: 'Location ID', value: values.locationId, min: 1, max: 15 },
    { field: 'locationName', label: 'Location Name', value: values.locationName, min: 1, max: 60 },
    { field: 'contactName', label: 'Contact Name', value: values.contactName, min: 1, max: 50 },
    { field: 'faxNumber', label: 'Fax Number', value: values.faxNumber, min: 1, max: 12 },
    { field: 'phoneNumber', label: 'Phone Number', value: values.phoneNumber, min: 1, max: 12 },
    { field: 'emailAddress', label: 'Email Address', value: values.emailAddress, min: 1, max: 65 },
    { field: 'autotecId', label: 'AutoTec ID', value: values.autotecId, min: 1, max: 8 },
    { field: 'experianID', label: 'Experian ID', value: values.experianId, min: 1, max: 50 },
    { field: 'address', label: 'Address', value: values.address, min: 1, max: 1 }
  ];
  validationHelper.validateLength(errors, lengthValidation);
  if (values.autotecId && !validationHelper.validateAutotecID(values.autotecId)) {
    errors.autotecId = '4 alphabetic characters + 4 numeric characters';
  }
  return errors;
};

const removeHyphens = value => value.replace(new RegExp('-', 'g'), '');

class AddEditLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      openAddress: false,
      addressList: { Address: { addressType: 'Address' } },
      addressType: '',
      physicalAuction: '',
      onlineAuction: '',
      addressPopulated: false,
      buttonColor: '#002053',
      autotecId: '',
      locationId: '',
      isActive: true,
      message: '',
      openDialog: false,
      primaryLocation: '',
      primaryLocationValue: '',
      customerId: '',
      linkCustomerId: '',
      showPrompt: <div />,
      addressSaved: false,
      autoTecIdExists: false,
      shouldPromptShow: false,
      openSaveDialog: false,
      paramCustomerId: (this.props.history.location && this.props.history.location.state && this.props.history.location.state.customerId) ? this.props.history.location.state.customerId : this.props.location.pathname.includes('/customer/') ? this.props.match.params.id : undefined,
    };
  }
  async componentDidMount() {
    const { locationLists, customers } = this.props.data;
    const { initialValues: { primaryLocationValue } } = this.props;
    await this.handleSaveAutoTecIdToState();
    if (customers && locationLists && locationLists.data.length > 0) {
      await this.props.actions.loadData(this.props.data.config, customers, locationLists.data, this);
      // await this.handlePullLocations();
    }
    if (primaryLocationValue) {
      this.handleUpdatePrimaryLocationIdValue();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data.locationLists === this.props.data.locationLists) {
      if (this.props.data.locationLists === undefined || this.props.data.locationLists.data.length === 0) {
        window.history.back();
      }
    }
    if (prevProps.initialValues.primaryLocationValue !== this.props.initialValues.primaryLocationValue) {
      this.handleUpdatePrimaryLocationIdValue();
    }

    if (this.state.shouldPromptShow !== this.props.isDirty) {
      this.shouldPromptExist();
    }

    if (this.state.isActive === null || this.state.isActive === undefined) {
      this.setState({ isActive: false });
    }
  }

  handleUpdatePrimaryLocationIdValue = () => {
    const { initialValues: { primaryLocationValue } } = this.props;
    this.setState({ primaryLocationValue: primaryLocationValue });
  }

  handlePullLocations = () => {
    const { config, locationLists } = this.props.data;
    this.props.actions.getLocations(0, null, config, locationLists.data, this);
  }

  handleClose = () => {
    this.setState({ openDialog: false, fetching: false, message: '' });
  }

  handleSaveAutoTecIdToState = () => {
    if (this.props.initialValues) {
      this.setState({ autotecId: this.props.initialValues.autotecId });
      this.setState({ locationId: this.props.initialValues.locationId });
    }
  }

  handleSave = (event) => {
    if (this.state.isActive !== this.props.initialValues.isActive) {
      const deactivate = this.state.isActive === false;
      const msg = deactivate ? 'You are about to deactivate this location. This will also disable any users that are ONLY associated with this location. Please type "confirm" to proceed.'
      : 'You are attempting to activate this location. Please type "confirm" to proceed.';
      const prompt = window.prompt(msg);
      if (prompt && prompt.toLowerCase() === 'confirm') {
        this.initiateSave(event);
      } else {
        return;
      }
    }
    else {
      this.initiateSave(event);
    }
  };

  initiateSave = (event) => {
    this.setState({ buttonColor: '#ddd', showPrompt: <div /> });
    const location = {
      locationId: event.locationId ? event.locationId : this.state.locationId,
      isActive: this.state.isActive,
      autotecId: removeWhiteSpace(event.autotecId),
      customerId: removeWhiteSpace(this.state.linkCustomerId),
      physicalAuction: this.state.physicalAuction,
      onlineAuction: this.state.onlineAuction,
      locationName: removeWhiteSpace(event.locationName),
      experianId: removeWhiteSpace(event.experianId),
      contact: {
        contactName: removeWhiteSpace(event.contactName),
        emailAddress: removeWhiteSpace(event.emailAddress),
        phoneNumber: removeWhiteSpace(removeHyphens(event.phoneNumber))
      },
      address: {
        addressLine1: removeWhiteSpace(this.state.addressList['Physical Address'].addressLine1),
        city: removeWhiteSpace(this.state.addressList['Physical Address'].city),
        county: removeWhiteSpace(this.state.addressList['Physical Address'].county),
        state: removeWhiteSpace(this.state.addressList['Physical Address'].state),
        postalCode: removeWhiteSpace(this.state.addressList['Physical Address'].postalCode),
        country: removeWhiteSpace(this.state.addressList['Physical Address'].country)
      }
    };

    if (this.state.addressList['Physical Address'].addressLine2) {
      location.address.addressLine2 = this.state.addressList['Physical Address'].addressLine2;
    }

    if (event.faxNumber) {
      location.contact.faxNumber = removeHyphens(event.faxNumber);
    }

    if (this.state.primaryLocationValue === 'Yes') {
      this.props.actions.addLocationAndCustomer(location, this.props.data.config, this);
    } else {
      this.props.actions.addEditLocation(location, this.props.data.config, this);
    }
  };

  primaryLocationAlert = () => {
    let dialog = <div />;
    if (this.state.message) {
      dialog =
        (<RenderDialog
          open={this.state.openDialog}
          confirmButton
          message={this.state.message}
          onClose={this.handleClose}
        />);
    } else {
      dialog = (<div />);
    }
    return dialog;
  }

  handleClose = () => {
    this.setState({ openSaveDialog: false, message: '', openDialog: false });
  };

  handleAddAddressClick = (event, address) => {
    event.preventDefault();
    if (this.state.customerId || this.state.linkCustomerId) {
      this.setState({
        openAddress: true,
        anchorEl: event.currentTarget,
        addressType: event.currentTarget.id
      });
    } else {
      this.setState({ openDialog: true, message: 'Please select a customer from the drop down' });
    }
  }

  handleAddressClose = () => {
    this.setState({
      openAddress: false,
      anchorEl: null
    });
  };

  handleLinkCheckChange = (value) => {
    this.setState({ linkCustomerId: value });
  }

  handleCheckChange = (event) => {
    if (event.target.value === 'Yes') {
      this.setState({
        message: 'This location will be set as the primary location for the customer.',
        openDialog: true
      });
      this.setState({ primaryLocationValue: event.target.value });
    }

    this.setState({ primaryLocationValue: event.target.value });
    // this.props.dispatch(change('AddEditLocationForm', event.target.name, event.target.value));
  }


  handlePhysicalCheckChange = (event) => {
    this.setState({physicalAuction: event.target.value });
    // this.props.dispatch(change('AddEditLocationForm', event.target.name, event.target.value));
  }

  handleOnlineCheckChange = (event) => {
    this.setState({onlineAuction: event.target.value });
    // this.props.dispatch(change('AddEditLocationForm', event.target.name, event.target.value));
  }
  checkAddress = (address) => {
    if (Object.keys(address).length > 0) {
      this.setState({ addressPopulated: true });
    } else {
      this.setState({ addressPopulated: false });
    }
  }

  handleAddressSave = (addressList) => {
    this.checkAddress(addressList);
    localStorage.setItem('addressList', JSON.stringify(addressList));
    this.setState({
      addressList,
      openAddress: false,
      addressSaved: true
    });
  }

  shouldPromptExist = () => {
    let showPrompt = <div />;
    let shouldPromptShow = false;
    if (this.props.isDirty) {
      shouldPromptShow = true;
      showPrompt = (<Prompt
        when={this.handleConfirmSaved}
        message="Any changes will be lost if you leave this screen. Would you like to continue?"
      />);
    }
    this.setState({ showPrompt, shouldPromptShow });
  }

  handleSearchAutoTecId = (event) => {
    const autoTecIdExists = validationHelper.checkValueExist('autotecId', event.target.value, this.props.data.locationLists.data);
    this.setState({
      autoTecIdExists
    });
  }

  handleAgree = () => {
    if (this.state.paramCustomerId) {
      this.props.history.push(`/locations/customer/${this.state.paramCustomerId}`);
    } else {
      this.props.history.push('/locations');
    }
  }

  saveAlert = () => {
    let dialog = <div />;
    if (this.state.openSaveDialog) {
      dialog =
        (<RenderConfirmationTimeoutDialog
          open={this.state.openSaveDialog}
          stayInAction={() => { this.handleClose(); }}
          handleIdleTimeout={() => { this.handleAgree(); }}
          timeoutInterval={this.props.data.config.ConfirmationTimeout}
          page={this.props.match.params.id ? 'Edit Location' : 'Add Location'}
        />);
    } else {
      dialog = (<div />);
    }
    return dialog;
  }


  handleToggleIsActive = (isActive, isCustomerDeactivated) => {
    if (isCustomerDeactivated && isActive === false) {
      this.setState({ openDialog: true, message: "Customer account is deactivated" });
      return;
    }
    let active = !isActive;

    this.setState({ isActive: active });
  };

  handleGetLocationId = (locationId) => {
    this.setState({ locationId });
  }

  renderActivityCheckBox = (optionsList, classes) => {
    const { isActive } = this.state;
    let locationId = localStorage.getItem('locationId');
    let locationList = JSON.parse(localStorage.getItem('person')).locations;
    let currentRole = locationList.filter(loc => loc.locationId === locationId)[0].role.name;
    let active = isActive;
    let activityCheckbox;

    if (this.props.match.params.id && this.props.data.locationLists.data && currentRole !== 'user') {
      let location = this.props.data.locationLists.data.filter(location => location.autotecId === this.props.initialValues.autotecId)[0];
      const customer = this.props.data.customers.customers.find(item => item.customerId === location.customerId);
      const syncBooleanValues = customer.isActive === false ? false : true;

      if (isActive === null) {
        active = location.isActive !== undefined && location.isActive !== null
          ? location.isActive
          : true;
      }

      activityCheckbox =
          <Field
              name="isActive"
              component={renderCheckBoxGroup}
              options={optionsList}
              className={classes.radioGroup}
              checked={active ? 'Yes' : 'No'}
              label="Active"
              handleCheckChange={() =>  { this.handleToggleIsActive(active, !customer.isActive) }}
              syncBooleanValues={syncBooleanValues}
            />
    }

    return activityCheckbox;
  }

  render() {
    const alertDialog = this.saveAlert();
    const { classes, handleSubmit } = this.props;
    const { message, openDialog } = this.state;
    const addressFieldList = [];
    const optionsList = [{ id: 1, label: 'Yes' }, { id: 2, label: 'No' }];
    const disabledMessage = "A customer must have a primary location. Set a new primary location to update this value.";

    const dialog = this.primaryLocationAlert();
    let address = {};
    Object.keys(this.state.addressList).forEach((key) => {
      address = this.state.addressList[key];
      if (address.addressType === 'Physical Address') {
        addressFieldList.push(<div className={classes.addressContainer} key={address.addressType}>
          <Field
            disabled
            name={address.addressType}
            id={address.addressType}
            component={renderTextArea}
            label={`*${address.addressType}`}
            className={classes.textAddressField}
            rows="1"
            rowsMax="1"
          />
          {
            address.country !== undefined ?
              <EditIcon
                name={address.addressType}
                id={address.addressType}
                onClick={e => this.handleAddAddressClick(e)}
              /> :
              <AddIcon
                name={address.addressType}
                id={address.addressType}
                onClick={e => this.handleAddAddressClick(e)}
              />
          }
        </div>);
      }
    });

    let form = <div align="center"><CircularProgress size={75} /></div>;
    const customerList = [];
    if (!this.state.fetching) {
      const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));
      let { customers } = this.props.data.customers;
      const product = ProductMap[sessionStorage.getItem('product')];
      customers = filterCustomersByProduct(product, customers, localStorage.getItem('customerId'), isATSysAdmin);
      if (!this.state.fetching) {
        customers.sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          return 0;
        });
        customers.forEach((customer) => {
          customerList.push({ value: customer.customerId, label: customer.name });
        });
      }


      form = (<Form onSubmit={handleSubmit(this.handleSave)}>
        <Card className={`${classes.card} AddEditLocationForm`} xs={12} sm={6}>
          <CardContent className={classes.content}>
            <div className="AutoComplete-div editBillingAutoComplete">
              {this.props.match.params.id ?
                <Field
                name="customerName"
                component={renderTextField}
                label="*Link to Customer"
                className={classes.textField}
                disabled
                divClassName={classes.marginStyle}
                /> :
                <AutoComplete
                  onChange={this.handleLinkCheckChange}
                  selectedSuggestions={this.state.linkCustomerId}
                  suggestions={customerList}
                  name="linkCustomer"
                  label=""
                  placeholder="*Link to Customer"
                />}
            </div>
            {
              message !== '' ? <RenderDialog
              open={openDialog}
              confirmButton
              message={message}
              onClose={this.handleClose}
              /> : <div/>
            }

            {this.state.primaryLocation === 'Yes' &&
              <Field
                name="primaryLocation"
                component={renderCheckBoxGroup}
                options={optionsList}
                className={`${classes.radioGroup} primaryCheckboxes`}
                checked={this.state.primaryLocationValue}
                label="Primary Location"
                handleCheckChange={this.handleCheckChange}
              />
            }
            <Tooltip title={this.props.initialValues.primaryLocation === 'Yes' ? disabledMessage : ""} placement="top">
            {this.state.primaryLocation === 'No' &&
              <div data-toggle="tooltip">
                <Field
                  name="primaryLocation"
                  component={renderCheckBoxGroup}
                  options={optionsList}
                  className={`${classes.radioGroup} primaryCheckboxes`}
                  checked={this.state.primaryLocationValue}
                  disabled={this.props.initialValues.primaryLocation === 'Yes'}
                  label="Primary Location"
                  handleCheckChange={this.handleCheckChange}
                />
              </div>
            }
            </Tooltip>

              <Field
                name="physicalAuction"
                component={renderCheckBoxGroup}
                options={optionsList}
                className={`${classes.radioGroup} primaryCheckboxes`}
                checked={this.state.physicalAuction}
                label="*Physical Auction"
                required={true}
                handleCheckChange={this.handlePhysicalCheckChange}
              />

              <Field
                name="onlineAuction"
                component={renderCheckBoxGroup}
                options={optionsList}
                className={`${classes.radioGroup} primaryCheckboxes`}
                checked={this.state.onlineAuction}
                label="*Online Auction"
                required={true}
                handleCheckChange={this.handleOnlineCheckChange}
              />
            <Field
              name="locationName"
              component={renderTextField}
              label="*Location Name"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />
            <Field
              name="contactName"
              component={renderTextField}
              label="*Contact Name"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />
            {!this.state.addressSaved && <p style={{ color: 'red' }}>The address is required</p>}
            {addressFieldList}
            <div>
              <StyledPopover
                open={this.state.openAddress}
                anchorEl={this.state.anchorEl}
                onClose={this.handleAddressClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'center',
                  horizontal: 'left',
                }}
                disableRestoreFocus
              >
                <AddressForm
                  autotecId={this.state.autotecId}
                  locationId={!this.props.location.pathname.includes('/customer/') ? this.props.match.params.id : ''}
                  isActive={this.state.isActive}
                  customerId={this.state.customerId}
                  handleAddressSave={this.handleAddressSave}
                  addressType={this.state.addressType}
                  handleAddressClose={this.handleAddressClose}
                  handleGetLocationId={this.handleGetLocationId}
                  addressList={this.state.addressList}
                  addressTypes={{ 'Physical Address': { addressType: 'Address' } }}
                />
              </StyledPopover>
            </div>
          </CardContent>
          <CardContent className={classes.content}>
            <Field
              name="phoneNumber"
              normalize={normalizePhone}
              component={renderTextField}
              label="*Phone Number"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />

            <Field
              name="faxNumber"
              normalize={normalizePhone}
              component={renderTextField}
              label="Fax Number"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />
            <Field
              name="emailAddress"
              component={renderTextField}
              label="*Email Address"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />
            <Field
              name="autotecId"
              component={renderTextField}
              label="*AutoTec ID"
              disabled={!!this.state.autotecId}
              className={classes.textField}
              divClassName={classes.marginStyle}
              onChange={e => this.handleSearchAutoTecId(e)}
            />
            <div
            style={(!this.state.autoTecIdExists ?
              {display: 'none' } :
              { display: 'block', color: 'red', fontSize: '0.75rem' })}
            >
            This value already exists
            </div>
            <Field
              name="experianId"
              component={renderTextField}
              label="Experian ID"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />
            {this.renderActivityCheckBox(optionsList, classes)}
          </CardContent>
        </Card>
        <div className={classes.buttonStyle}>
          <Button variant="raised"
            className={classes.buttonSize}
            style={((this.props.valid && this.state.addressPopulated)) && this.state.addressSaved && !this.state.autoTecIdExists ? { background: this.state.buttonColor } : { background: '#ddd' }}
            disabled={!(this.props.valid && this.state.addressPopulated) || this.state.buttonColor === '#ddd' || !this.state.addressSaved || this.state.autoTecIdExists}
            type="submit">{(this.state.buttonColor === '#ddd') ? 'Please wait...' : 'Save'}</Button>
          <div className={`${classes.messageStyle} mandatory-msg`}>* Required fields</div>
        </div>
      </Form>);
    }
    return (
      <Layout
        className="App"
        showMenu
        menuTitle=""
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        <Paper className={classes.paperStyle}>
          {dialog}
          {alertDialog}
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title" className="lightH2">
                {(this.props.match.params.id && !this.props.location.pathname.includes('/customer/')) ? 'Edit Location' : 'Add Location'}
              </Typography>
              {this.state.showPrompt}
              <IconButton title="close" component={Link} to={ this.state.paramCustomerId ? `/locations/customer/${this.state.paramCustomerId}` : '/locations'}>
                <Close color="disabled" />
              </IconButton>
            </Toolbar>
          </AppBar>
          {form}
        </Paper>
      </Layout>
    );
  }
}

AddEditLocation.propTypes = {
  classes: PropTypes.shape().isRequired
};

const checkPrimaryLocation = (customers, location) => {
  if (!location.locationId) {
    return 'No';
  }

  let customer = '';
  if (customers && customers.customers) {
    customer = customers.customers.find(item => item.primaryLocationId === location.locationId);
  }

  if (customer) {
    return 'Yes';
  }

  return 'No';
};

const initialValues = (locations, customers, ownProps) => {
  let location = !ownProps.location.pathname.includes('/customer/') ?
    locations.find(item => item.locationId === ownProps.match.params.id) :
    { isActive: true, contact: {}, address: {} };

  if (!location) {
    location = {
      isActive: true,
      contact: {},
      address: {}
    };
  }

  if (!location.contact) {
    location.contact = {};
  }

  let primaryLocation = '';
  if (customers && location.locationId) {
    primaryLocation = checkPrimaryLocation(customers, location);
  }

    const locationRecord = {
      locationId: location.locationId,
      autotecId: location.autotecId,
      customerName: location.customerId ?
      customers.customers.find(c => c.customerId === location.customerId).name :
      ownProps.location.pathname.includes('/customer/') ?
      customers.customers.find(c => c.customerId === ownProps.match.params.id).name : '',
      linkCustomer: ownProps.location.pathname.includes('/customer/') ? ownProps.match.params.id : location.customerId,
      locationName: location.locationName,
      experianId: location.experianId,
      contactName: location.contact.contactName,
      emailAddress: location.contact.emailAddress,
      phoneNumber: normalizePhone(location.contact.phoneNumber),
      primaryLocation: primaryLocation,
      primaryLocationValue: primaryLocation,
      physicalAuction: location.physicalAuction,
      onlineAuction: location.onlineAuction,
      isActive: location.isActive != null ? location.isActive : true
  };

  if (location.contact.faxNumber) {
    locationRecord.faxNumber = normalizePhone(location.contact.faxNumber);
  }

  return locationRecord;
};

const mapStateToProps = (state, ownProps) => ({
  data: {
    addEditLocation: state.addEditLocation,
    customers: state.customers.customers,
    config: state.config.config,
    locations: state.search.locations,
    locationLists: state.search.locationsList
  },
  isDirty: isDirty('AddEditLocationForm')(state),
  initialValues: initialValues(
    state.search && state.search.locationsList ? state.search.locationsList.data : [],
    state.customers.customers, ownProps
    )
});

const buildCustomerRequest = (customer) => {
  const customerToSave = {
    customerId: customer.customerId,
    addressLine1: customer.billingAddress.addressLine1,
    city: customer.billingAddress.city,
    country: customer.billingAddress.country,
    county: customer.billingAddress.county,
    postalCode: customer.billingAddress.postalCode,
    state: customer.billingAddress.state,
    name: customer.name,
    customerGroupId: customer.customerGroup,
    contactName: customer.contact.contactName,
    emailAddress: customer.contact.emailAddress,
    phoneNumber: removeHyphens(customer.contact.phoneNumber),
    availableReports: customer.authorizedMethodIds,
    vhrOwnership: customer.vhrOwnership,
    primaryLocationId: customer.primaryLocationId,
    autotecId: customer.autotecId
  };

  if (customer.billingAddress.addressLine2) {
    customerToSave.addressLine2 = customer.billingAddress.addressLine2;
  }

  if (customer.invoiceMax) {
    customerToSave.invoiceMax = customer.invoiceMax;
  }

  if (customer.invoiceMin) {
    customerToSave.invoiceMin = customer.invoiceMin;
  }

  if (customer.submissionTypes) {
    customerToSave.submissionTypes = customer.submissionTypes;
  }

  return customerToSave;
};

const mapDispatchToProps = dispatch => ({
  actions: {
    getLocations: (pageSize, key, locationData, config, self) => {
      dispatch(search('locations', pageSize, key, config));
    },
    addEditLocation: (location, config, self) => {
      dispatch(addEditLocation(location, config)).then((o) => {
        if (o.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
          self.setState({ message: 'Record saved', openSaveDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
          dispatch(getCustomerGroups(config));
          dispatch(search('person-locations', 0, null, config))
          dispatch(search('locations', 0, null, config, true));
          dispatch(getCustomers(config));
          dispatch(search('persons', 0, null, config));
        }
      }).catch((e) => {
        self.setState({ openDialog: true, buttonColor: '#002053', message: e.response.data });
      });
    },
    addLocationAndCustomer: (location, config, self) => {
      dispatch(addEditLocation(location, config)).then((savedLocation) => {
        if (savedLocation.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
          const customer = self.props.data.customers.customers.find(item => item.customerId === savedLocation.value.data.customerId);
          customer.primaryLocationId = savedLocation.value.data.locationId;
          customer.autotecId = savedLocation.value.data.autotecId;
          const customerToSave = buildCustomerRequest(customer);
          dispatch(addEditCustomer(customerToSave, config)).then((savedCustomer) => {
            if (savedCustomer.action.type === 'ADD_EDIT_CUSTOMER_SAVE_FULFILLED') {
              dispatch(getCustomerGroups(config));
              dispatch(search('person-locations', 0, null, config));
              dispatch(search('locations', 0, null, config, true));
              dispatch(getCustomers(config));
              dispatch(search('persons', 0, null, config));
              self.setState({ message: 'Record saved', openSaveDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
            }
          });
        }
      }).catch(() => {
        self.setState({ openDialog: true, buttonColor: '#002053', message: 'Experian ID or AutoTec ID already exists for another location.' });
      });
    },
    loadData: (config, customers, locationLists, self) => {
      try {
        const locationId = !self.props.location.pathname.includes('/customer/') ? self.props.match.params.id : undefined;
        console.log("locationId", locationId)
        let location = locationLists.find(item => item.locationId === locationId);
        const customer = location ? customers.customers.find(customerVal => customerVal.customerId === location.customerId) : null;
        if (customer || self.props.location.pathname.includes('/customer/')) {
          const customerId = self.props.location.pathname.includes('/customer/') ? self.props.match.params.id : customer.customerId;
          self.setState({ customerId, linkCustomerId: customerId });
        }
        if (!location) {
          location = {
            address: {}
          };
        } else if (Object.keys(location).length >= 7) {
          self.setState({ addressPopulated: true });
        } else {
          self.setState({ addressPopulated: false });
        }
        const primaryLocation = checkPrimaryLocation(customers.customers, location);
        self.setState({
          fetching: false,
          addressSaved: !!location.address,
          addressList: {
            'Physical Address': {
              addressType: 'Physical Address',
              addressLine1: location.address && location.address.addressLine1 ? location.address.addressLine1 : '',
              addressLine2: location.address && location.address.addressLine2 ? location.address.addressLine2 : '',
              country: location.address && location.address.country ? location.address.country : '',
              county: location.address && location.address.county ? location.address.county : '',
              city: location.address && location.address.city ? location.address.city : '',
              state: location.address && location.address.state ? location.address.state : '',
              postalCode: location.address && location.address.postalCode ? location.address.postalCode : '',
              buttonColor: '#002053'
            }
          },
          primaryLocation,
          physicalAuction: location.physicalAuction ? location.physicalAuction : 'No',
          onlineAuction: location.onlineAuction ? location.onlineAuction : 'No',
          primaryLocationValue: primaryLocation,
          isActive: location.isActive != null ? location.isActive : true
        });
      } catch (e) {
        console.error(e);
        window.history.back();
      }
    }
  }
});


const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'AddEditLocationForm',
  enableReinitialize: true,
  validate
})(AddEditLocation));

const ConnectedAddEditLocation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditLocation;


// WEBPACK FOOTER //
// ./src/components/Customer/Location/AddEditLocation.js